import React, { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";

export const DeactiveAccountContext = createContext();
export const ACTIONS = {
  SET_DEACTIVE_ACCOUNT: "SET_DEACTIVE_ACCOUNT",
  SET_DEACTIVE_ACCOUNT_RESPONSE: "SET_DEACTIVE_ACCOUNT_RESPONSE"
};
const initialState = {
  deactiveAccount: false,
  deactiveAccountResponse: false
};
const DeactiveAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_DEACTIVE_ACCOUNT_RESPONSE: {
      return {
        ...state,
        deactiveAccountResponse: action.payload,
      };
    }
    case ACTIONS.SET_DEACTIVE_ACCOUNT: {
      return {
        ...state,
        deactiveAccount: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const DeactiveAccountContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(DeactiveAccountReducer, initialState);


  useEffect(() => {
    if (state.deactiveAccount) {
      // eslint-disable-next-line no-undef
      Liferay.Service(
        '/user/get-user-by-email-address',
        {
          // eslint-disable-next-line no-undef
          companyId: Liferay.ThemeDisplay.getCompanyId(),
          // eslint-disable-next-line no-undef
          emailAddress: Liferay.ThemeDisplay.getUserEmailAddress()
        },
        function(obj) {
          LiferayService.setDesactiveAccount(properties.base_url_api, obj.screenName)
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_DEACTIVE_ACCOUNT_RESPONSE,
            });
            dispatch({
              payload: false,
              type: ACTIONS.SET_DEACTIVE_ACCOUNT,
            });
          })
        }
      );
    }
  }, [state.deactiveAccount]);
  
  return (
    <DeactiveAccountContext.Provider value={[state, dispatch]}>
      {children}
    </DeactiveAccountContext.Provider>
  );
};
export default DeactiveAccountContextProvider;